export const Home = {
    Title: {
        '置顶课程': 'Top courses',
        '待办事项': 'Todo',
        '其他课程': 'other courses',
        '我教的':'Teach',
        '我协助的':'Assist',
        '我学的':'Study',
    },
    Handle: {
        '课堂排序': 'Sort Classroom',
        '归档管理': 'Archive',
        '创建加入课程': 'Create/Join',
        '创建课程': 'Create course',
        '编辑课程':'Edit',
        '加入课程': 'Join',
        '查看全部': 'View All',
        '从示范包创建':'Create from demo',
        '资料': 'Material',
        '忽略': 'ignore',
        '已忽略':'aready ignore all!',
        '个人作业': 'Personal',
        '份作业待批改': 'homeworks to be corrected',
        '点击查看更多': 'Click to see more',
        '收起更多学期':'Upfold more semesters ↑',
        '展开更多学期':'Downfold more semesters ↓',
    },
    Classroom:{
        "直播中":"Living",
        "会议上课中":"Meeting/class",
        "上课中":"In class",
        "会议中":"Meeting",
        "您有":"Has ",
        "个课堂正在上课":" classes are in class",
    },
    "首页":"Home",
    "待办":"Todo",
    "待办事项":"Todo lists",
    "课堂":"Class",
    "私信":"Letter",
    "我的":"Me",
    "发现":"Discover",
    "期末突击课":"Final Assault",
    "不挂科":"Pass",
    "期末不挂科":"Pass",
    "正在跳转中":"Jumping...",
    "登录中":"Logging in...",
    "待审核":"To be reviewed",
    "已通过":"Passed",
    "已拒绝":"Rejected",
    "提交报名":"Submit registration",
    "报名信息":"Registration information",
    "拒绝":"Refuse",
    '通过':"Pass",
    "选择加入的标签":"Select tag to join",
    "课程名称":"Course name",
    "立即报名":"Register now",
    "已报名审核中":"Registered, under review",
    "您无法重复加入课程":"You cannot join the course again",
    "审核中":"Under review",
    "被拒绝":"Rejected",
    "您的报名被拒绝如有疑问请与课程老师联络":"Your application has been rejected. If you have any questions, please contact the course teacher",
    "课堂派会根据选择的类型定制课程教学活动模块展示您可手动变更定制结果":"According to the selected type, we will customize the module display of course teaching activities, and you can manually change the customized results",
    "不使用模板":"Do not use templates",
    "混合课程":"Mixed course",
    "线下课程":"Offline course",
    "在线课程":"Online course",
    "实验课":"Experiment course",
    "社会实践课":"Social Practice Course",
    "其他":"Other",
    "选择课程模板":"Select course template",
    "请输入课程介绍":"Please enter the course introduction",
    "要创建":"Are you sure to create",
    "吗":"?",
    "开启您的轻松建课之旅":"Start the journey of easy course building",
    "创建成功":"Creat successfully",
    "报名设置":"Enrollment Settings",
    "审核方式":"Audit method",
    "审核后自动加入标签":"Automatically add tags after approval",
    "默认标签":"Default label",
    "报名信息收集":"Registration information collection",
    "添加更多报名信息问题":"Add more registration information questions",
    "收集信息标题":"Collect Information Title",
    "请输入标题":"Please enter a title",
    "自动审核":"Automatic approval",
    "手动审核":"Manual audit",
    "要恢复":"Are you sure to restore",
    "您":"You",
    "和您的学生":"and your students",
    "可以重新在此课程中互动":"can interact in this course again",
    "此课程会在课程首页上显示":"This course will be displayed on the course homepage",
    "取消归档成功":"Archive canceled successfully",
    "输入课堂的6位加课码":"Enter the 6-digit join code",
    "也可以使用微信扫一扫扫描课堂二维码加入":"You can also use WeChat to scan QR code to join",
    "进入课程":"Entering the course",
    "点击返回至首页":"Back to Home",
    "前往认证":"Go to Certification",
    "您在这个课程的任何信息或评论将被永久删除":"Any information or comments you have on this course will be permanently deleted.",
    "警告此操作无法撤销":"Warning: This operation cannot be undone",
    "继续操作或关闭":"Continue or close",
    "您可以在我的归档课堂里面查看此课堂":"You can view this class in My Archive Class",
    "归档自己":"Archive yourself",
    "归档全班":"Archive the whole class",
    "要复制":"Are you sure to copy",
    "请输入新课程名称":"Please enter a new course name",
    "复制内容":"Copy content",
    "复制学员":"Copy Student",
    "复制助教":"Copy teaching assistant",
    "复制资料":"Copy material",
    "复制外链":"Copy outer chain",
    "确定要转让":"Are you sure to transfer",
    "此课程的任何信息或评论将被永久转让":"Any information or comments on this course will be permanently transferred",
    "请输入转让老师的账号手机号邮箱":"Please enter the account/mobile number/email of the transfer teacher",
    "没有找到匹配的结果":"No matching results found",
    "课程排序":"Course sequencing",
    "搜索我教的课程":"Search for courses I teach",
    "请输入登录密码验证":"Please enter the login password for verification",
    "加课码已重置":"The join code has been reset",
    "确定要删除":"Are you sure to delete",
    "请按照提示输入":"Please enter according to the prompts",
    "删除后数据将无法恢复":"Data cannot be recovered after deletion!",
    "确定删除":"Delete",
    "再想想":"Think again",
    "要归档管理此课程吗":"Do you want to archive this course",
    "成功":"successfully",
    "课程":"Course",
    "确定要退课":"Are you sure to quit",
    "确定复制":"Confirm Replication",
    "请输入课程名":"Please enter the course name",
    "归档成功":"Archive successfully",
    "删除失败":"Delete failed",
    "请输入要转让的老师的账号":"Please enter the account number of the teacher to be transferred",
    "转让成功":"Transfer successfully",
    "搜索我学的课程":"Search for courses I have learned",
    "前往绑定":"前往绑定",
    "已成功加入":"Successfully joined",
    "课堂名称":"Class name",
    "请输入课堂名称":"Please enter the class name",
    "教学班级名称":"Name of teaching class",
    "请输入教学班级名称":"Please enter the name of the teaching class",
    "选择学年":"Select school year",
    "选择学期":"Select semester",
    "更多信息":"More information",
    "请输入大于0的数":"Please enter a number greater than 0",
    "请输入学时":"Please enter the class hours",
    "请输入授课地点":"Please enter the teaching location",
    "对机构后台可见":"Visible to the background system",
    "确认":"Confirm",
    "姓名":"Full name",
    "手机":"cell-phone number",
    "学号":"Student ID",
    "工号":"Staff number",
    "学校":"School",
    "公司":"Company",
    "第一学期":"First semester",
    "第二学期":"Second semester",
    "请填写课程名称":"Please fill in the course name",
    "请选择学年":"Please select a school year",
    "请选择学期":"Please select a semester",
    "编辑成功":"Successfully edited",
    "创建":"Create",
    "学生需额外补充下列信息才能加入课堂":"Students need to add the following information to join the class",
    "自然班级":"Natural class",
    "入学年月":"Date of admission",
    "新建课程": "Create course",
    "我的课程":"My course",
    "课程广场":"Course square",
    "我的特权":"My prerogative",
    "查看全部待办":"View all to dos",
    "暂无待办事项":"No to-do items",
    "玩转课堂派":"Familiar with Classroom Style",
    "推荐课程":"Recommended courses",
    "课程筛选":"Course screen",
    "请选择课程":"Please select a course",
    "选择课程":"Select a course",
    "全部课程":"All courses",
    "教":"Teach",
    "学":"Learn",
    "已经全部加载完了，没有更多了":"All have been loaded, there is no more",
    "最早":"The earliest",
    "共有":"There are",
    "后可参与评论":",than you can comment.",
    "申请加入虚拟教研室可以继续阅读和名师一起研讨引用优质的教学资源":"If you apply to join the virtual teaching and research room, you can continue to read, discuss with famous teachers, and quote high-quality teaching resources.",
    "去评论":"To comment",
    "活动详情":"Event details",
    "编辑内容":"Edit content",
    "教研室公告":"Notice of Teaching and Research Office",
    "请输入公告内容":"Please enter the notice content",
    "暂无公告内容":"No notice content",
    "公告内容不允许为空":"The notice content cannot be empty!",
    "发送申请":"Send request",
    "请先填写个人信息发送申请发起人审核通过后可以参与虚拟教研室的建设同时还享有":"Please fill in your personal information first and send the application. After approval, the sponsor can participate in the construction of virtual teaching and research room, and enjoy",
    "引用该教研室的资源和共建的样板课程参与培训研讨":"Quote the resources of the teaching and research department and the model courses jointly built to participate in the training discussion",
    "职称":"Title",
    "请选择职称":"Please select a professional title",
    "申请成功":"Successful application",
    "暂无申请消息":"No application message",
    "申请时间":"Application time: ",
    "处理申请":"Process Request",
    "提交信息":"Submit information",
    "内容不允许为空":"Content cannot be empty!",
    "引用样板课程新建课程":"Reference a sample course to create a new course",
    "教学班级":"Teaching class",
    "点击选择学年":"Click to select the school year",
    "点击选择学期":"Click to select semester",
    "引用内容":"References",
    "成绩设置":"Score setting",
    "引用到样板课程":"Reference to a Model course",
    "教研室基本信息":"Basic information",
    "教研室名称":"Name",
    "教研室封面":"Cover",
    "建设范围":"Construction scope",
    "建设内容":"Construction content",
    "发起单位":"Initiate units",
    "教研室简介":"Introduction to Teaching and Research Office",
    "教学主体及目标":"Teaching subject and goal",
    "教研主体类型":"Type of teaching and research subject",
    "学分":"Credit: ",
    "核心教材":"Core teaching materials:",
    "专业名称":"Major name",
    "专业级别":"Major level",
    "专业简介":"Major introduction",
    "请在PC端添加主题及目标":"Please add theme and target on PC side",
    "课程列表":"Course list",
    "专业列表":"Major list",
    "教学研究改革主题":"Teaching Research Reform theme",
    "教研室主题":"Teaching and Research Office theme",
    "该小节暂无内容":"No content in this section",
    "请在PC端添加章节课程":"Please add a chapter course on the PC",
    "引用到":"Reference to",
    "已分配占比":"Proportion allocated",
    "总成绩":"Total score",
    "整课被引用次数":"Cited times of the whole lesson",
    "引用课程内容到":"Quote course content to...",
    "课程目录":"Course catalog",
    "成绩设置考核方案":"Score Setting (Appraisal Scheme)",
    "课程达成度":"Course achievement",
    "暂无试题":"No test questions",
    "已经向该教研室的管理团队发起申请请耐心等待审核":"The application has been submitted to the management team of the teaching and research department. Please wait patiently for approval",
    "查看详情需要加入教研室确认加入":"To view the details, you need to join the teaching and research office. Are you sure you want to join?",
    "最新活动":"Latest activities",
    "更多":"more",
    "人在讨论":" people are discussing",
    "全部动态":"All dynamic",
    "赞了我的":"Like me",
    "研讨会议":"Seminar",
    "样板课程":"Model course",
    "个研讨":"discussions",
    "个动态":"dynamic",
    "个成员":"members",
    "我创建的":"Created",
    "我参与的":"Involved",
    "按创建时间":"By creation time",
    "按名称":"By name",
    "回放":"Playback",
    "图形验证码":"Graphic verification code",
    "短信验证码":"SMS verification code",
    "发送验证码":"Send verification code",
}
